import {
    Menu,
    MenuButton,
    MenuList,
    MenuItem,
    Button
  } from '@chakra-ui/react'
import { FaChevronDown } from 'react-icons/fa'
import { updateDoc, serverTimestamp } from 'firebase/firestore'
import { useAuth } from '../contexts/AuthContext'

// Currently supports New, In Progress & Completed statuses only
export default function StatusChangeDropdown( { currentStatus, statuses, docRef, fieldValue } ){
    const { currentUser } = useAuth()


    const handleChangeStatus = async (newStatus) => {
        const timestamp = serverTimestamp()
        const updateData = {
            [fieldValue]: newStatus,
            'Last Edited By': {
                Email: currentUser.email,
                Name: currentUser.displayName,
                photoURL: currentUser.photoURL,
                uid: currentUser.uid
            }
        }
        const dateFieldName = `Date ${newStatus}`.replace(/\//g, " ");
        updateData[dateFieldName] = timestamp;
        await updateDoc(docRef, updateData)
    }

    return(
        <>
            <Menu>
                <MenuButton 
                    as={Button} 
                    size='xs'
                     colorScheme={currentStatus == 'New' ? 'red' : 
                                     currentStatus == 'In Progress' ? 'orange' : 
                                     currentStatus == 'Awaiting Review/Delivery Confirmation' ? 'cyan' :
                                     'green'} 
                    rightIcon={<FaChevronDown />}
                    textTransform='uppercase'
                    whiteSpace='normal'
                    h='auto'
                    py={1}
                    fontSize={currentStatus === 'Awaiting Review/Delivery Confirmation' ? '2xs' : 'xs'}
                    >
                    {currentStatus}
                </MenuButton>
                <MenuList>
                    {statuses && statuses.map((status) => (
                        <>
                            <MenuItem 
                                onClick={() => handleChangeStatus(status)} 
                                isDisabled={status == currentStatus}
                                fontWeight={'bold'}
                                color={status == 'New' ? 'red' : 
                                        status == 'In Progress' ? 'orange' : 
                                        status == 'Awaiting Review/Delivery Confirmation' ? 'cyan' :
                                        'green'}
                                fontSize={status === 'Awaiting Review/Delivery Confirmation' ? '2xs' : 'sm'}
                                >
                                    {status}
                            </MenuItem>   
                       </>
                ))}
                </MenuList>
            </Menu>
       
        </>
    )
}